<ca-modal-container modalTitle="Edit Result" (dismiss)="dismiss($event)">
    <form #resultForm="ngForm" (ngSubmit)="resultForm.valid && submit()" novalidate>
        <input
            class="mb-2 form-control"
            id="name"
            type="text"
            [(ngModel)]="data.title"
            #title="ngModel"
            id="title"
            placeholder="Title"
            name="title"
            required
            maxlength="{{ titleLengthLimit }}"
            data-uit="result-detail-page-edit-title"
        />
        <textarea
            *ngIf="showDescription"
            id="description"
            class="form-control"
            [(ngModel)]="data.description"
            #description="ngModel"
            id="description"
            placeholder="Description"
            name="description"
            maxlength="{{ descriptionLengthLimit }}"
            data-uit="result-detail-page-edit-description"
        ></textarea>

        <div class="modal-buttons">
            <button
                type="submit"
                caAutoFocus
                data-uit="result-detail-page-edit-save-button"
                [disabled]="!resultForm.valid || isSubmitting"
                class="btn btn-primary mt-3"
            >
                Save
            </button>
        </div>
    </form>
</ca-modal-container>
